<ng-container *ngIf="!isLinear; else linearIcon">
    <i class="theme-warning warning-color" *ngIf="!isEpcotEnabled"></i>
    <i class="theme-warning warning-color" *ngIf="isEpcotEnabled"></i>
</ng-container>

<ng-template #linearIcon>
    <i class="theme-warning"></i>
</ng-template>
